import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'

import ChartFearGreed from 'Component/chart/fear_greed'

import { formatDate } from 'Util';
import renderingGuide from 'Component/title/guide_content';

const FearGreed = () => {

  const { tickerDetail } = useSelector((state) => state.stock);
  const [data, setData] = useState();

  useEffect(() => {
    if (tickerDetail && tickerDetail.fg && tickerDetail.fg.length > 0) {
      const x = [];
      const y1 = [];
      const y2 = [];

      let list = [...tickerDetail.fg];
      list = list.reverse();
      list.forEach(element => {
        x.push(formatDate(element.TRD_DT));
        y1.push(element.INVEST_ATTRACTIVE);
        y2.push(element.PRICE);
      });

      setData({
        x: x,
        y1: y1,
        y2: y2
      })
    } else {
      setData(null);
    }
  }, [tickerDetail])

	return (
    <>
      { data && 
        <div className="content4">
          <div className="cont">
            <ChartFearGreed data={data} title={['투자매력도', '주가']} showTitle={false} showTip={false} />
          </div>
        </div>
      }
    </>
  );
}

export default FearGreed;
